<template lang="pug">
v-app
  DialogArteDivulgacao(ref="dialogArte")
  dialog-historico-alteracoes(ref="dialogHistorico")

  DialogCupomForm(ref="dialogCupom", :metricas28d="metricas28d", :cupons="cupons", @saved="getCupons", @ativado="abrirArteCupom($event, true, 'criacao')")

  v-dialog(v-model="dialog.baixarImagem", v-if="dialog.baixarImagem", persistent, max-width="600")
    v-card.Poppins(style="border: 6px solid #d2d2d7!important;border-radius: 17px")
      v-card-title
        v-layout(row, wrap)
          v-flex.md11
      v-card-text
        v-layout(row, wrap, v-if="loadingDialog")
          v-flex.xs12.text-xs-center
            v-progress-circular(:width="3", :size="40", color="primary", indeterminate)
        v-layout(row, wrap, v-else)
          v-flex.xs12.text-xs-center
            img#image_cupom(:src="image", style="border-radius:13px; width: 100%")

      v-card-actions
        v-spacer
        v-btn.Poppins(type="button", flat, color="gray", @click="dialog.baixarImagem = false; image = null;") Fechar
        v-btn.elevation-0.white--text.Poppins(type="button", color="primary", @click="downloadImageCupom();", target="_blank", style="border-radius: 7px")
          img.mr-2(:src="require('@/assets/images/icons/downloadFill.svg')", style="max-width: 20px;")
          span Baixar

  //- ─── Dialog: Confirmar Template (componente compartilhado com Marketing.vue) ─
  dialog-ativar-cupom-template(
    ref="dialogTemplate",
    :estabelecimento="estabelecimentoSelecionado",
    :cupons="cupons",
    :bloqueio="bloqueioCupom",
    :metricas28d="metricas28d",
    :bairros-estabelecimento="bairrosEstabelecimento",
    :is-cardapio-digital="isCardapioDigital",
    :loading-bairros="loadingBairros",
    :loading-metricas="loadingPedidos28d",
    @saved="getCupons",
    @ativado="abrirArteCupom($event, true, 'template')"
  )

  WarningSelect(v-show="!estabelecimentoSelecionado")

  v-container(grid-list-xl, fluid, v-if="estabelecimentoSelecionado")
    v-layout(row, wrap, align-center)
      v-flex
        .headline.font-weight-bold.voltar-titulo(@click="$router.push({ name: 'Marketing' })", style="cursor:pointer;display:inline-flex;align-items:center;gap:4px;")
          v-icon(size="20", color="rgba(0,0,0,0.87)") chevron_left
          span Cupons de Desconto
        .body-1.grey--text.text--darken-1 Gerencie os cupons vinculados ao seu estabelecimento

    //- ─── Insights de Desempenho dos Cupons ─────────────────────────────────────
    v-container(grid-list-xl, fluid).px-0.pb-2
      v-layout(row, wrap, align-center).mb-2
        v-flex(xs12)
          .insights-title.Poppins Desempenho dos Cupons
          .insights-subtitle.Poppins Pedidos com cupom nos últimos 28 dias

      v-layout(row, wrap)
        v-flex.xs12.sm6.lg2dot4
          .kpi-card
            .kpi-card__icon-wrap.kpi-card__icon-wrap--green
              v-icon(style="color:#1d9a5a;font-size:22px") local_offer
            .kpi-card__label.Poppins Vendas com Cupom
            .kpi-card__value--skeleton(v-if="loadingPedidos28d")
            .kpi-card__value.Poppins(v-else) {{ kpisCupom.totalVendas | currency }}
            .kpi-card__sub.Poppins(v-if="!loadingPedidos28d") {{ kpisCupom.qtdPedidos | number }} pedidos

        v-flex.xs12.sm6.lg2dot4
          .kpi-card
            .kpi-card__icon-wrap.kpi-card__icon-wrap--blue
              v-icon(style="color:#3060CA;font-size:22px") confirmation_number
            .kpi-card__label.Poppins Pedidos com Cupom
            .kpi-card__value--skeleton(v-if="loadingPedidos28d")
            .kpi-card__value.Poppins(v-else) {{ kpisCupom.qtdPedidos | number }}
            .kpi-card__sub.Poppins(v-if="!loadingPedidos28d") no período

        v-flex.xs12.sm6.lg2dot4
          .kpi-card
            .kpi-card__icon-wrap.kpi-card__icon-wrap--purple
              v-icon(style="color:#6432b4;font-size:22px") person_add
            .kpi-card__label.Poppins Novos Clientes Atraídos
            .kpi-card__value--skeleton(v-if="loadingPedidos28d")
            .kpi-card__value.Poppins(v-else) {{ kpisCupom.novosComCupom | number }}
            .kpi-card__sub.Poppins(v-if="!loadingPedidos28d") 1ª compra no estabelecimento

        v-flex.xs12.sm6.lg2dot4
          .kpi-card
            .kpi-card__icon-wrap.kpi-card__icon-wrap--blue
              v-icon(style="color:#3060CA;font-size:22px") people
            .kpi-card__label.Poppins
              span Pedidos Recorrentes
              v-icon.kpi-card__info(small, @click="dialogTipRecorrentes = true") info_outline
            .kpi-card__value--skeleton(v-if="loadingPedidos28d")
            .kpi-card__value.Poppins(v-else) {{ kpisCupom.recorrentesComCupom | number }}
            .kpi-card__sub.Poppins(v-if="!loadingPedidos28d") clientes que já compraram

        v-flex.xs12.sm6.lg2dot4
          .kpi-card
            .kpi-card__icon-wrap.kpi-card__icon-wrap--red
              v-icon(style="color:#FF4B4B;font-size:22px") money_off
            .kpi-card__label.Poppins Desconto Concedido
            .kpi-card__value--skeleton(v-if="loadingPedidos28d")
            .kpi-card__value.Poppins(v-else) {{ kpisCupom.totalDesconto | currency }}
            .kpi-card__sub.Poppins(v-if="!loadingPedidos28d") custo dos cupons da loja

    //- ─── Alertas de Bloqueio ────────────────────────────────────────────────────
    v-container(grid-list-xl, fluid, v-if="bloqueioCupom.ativo").px-0.pb-0.mt-2
      v-layout(row, wrap)
        v-flex(xs12)
          message-panel(
            type="danger",
            :title="bloqueioCupom.motivo.titulo",
            :message="bloqueioCupom.motivo.mensagem"
          )

    //- ─── Templates de cupons (vindo da API, agrupados por categoria) ───────────
    v-container(grid-list-xl, fluid, v-if="templatesCarregando").px-0.pb-0.mt-4
      v-layout(row, wrap).mb-4
        v-flex(xs12)
          .destaque-section-header
            .insights-title.Poppins.skeleton-line.skeleton-line--lg
            .insights-subtitle.Poppins.skeleton-line.mt-2
      div.mb-2
        .destaque-sub-title.skeleton-line.skeleton-line--md
        .destaque-sub-desc.skeleton-line.mt-1
      v-layout(row, wrap).mb-4
        v-flex(xs12, sm6, md4, lg3, v-for='n in 4', :key="'sk-'+n")
          .cupomCardDestaque.tplSkeleton
            .cupomCard__header
              .tplSkeleton__valor.skeleton-line.skeleton-line--xl
              .tplSkeleton__label.skeleton-line.mt-2
            .cupomCard__body
              .skeleton-line.mt-2
              .skeleton-line.skeleton-line--short.mt-2
              .skeleton-line.skeleton-line--short.mt-2
              .tplSkeleton__cta.skeleton-line.mt-3

    v-container(grid-list-xl, fluid, v-if="!templatesCarregando && sectionsFiltradas.length").px-0.pb-0.mt-4
      v-layout(row, wrap).mb-4
        v-flex(xs12)
          .destaque-section-header
            .insights-title.Poppins
              v-icon(style="color:#1a1a1a;font-size:24px;margin-right:8px;vertical-align:middle;") {{ isCardapioDigital ? 'local_offer' : 'star' }}
              | {{ isCardapioDigital ? 'Sugestões de Cupons' : 'Cupons de Destaque' }}
              span.cupom-smart-badge.Poppins(v-if="isInteligente")
                v-icon(x-small, style="color:#1d9a5a;") auto_awesome
                |  Inteligente
            .insights-subtitle.Poppins
              span(v-if="isCardapioDigital") Ative cupons para atrair mais clientes no seu cardápio digital
              span(v-else) Ative um cupom e ganhe destaque na lista principal do app
            .destaque-benefit-badge.Poppins(v-if="!isCardapioDigital")
              v-icon(x-small, style="color:#1a1a1a;") trending_up
              span Sua loja aparece em destaque para mais clientes

      template(v-for='(secao, sidx) in sectionsFiltradas')
        div(:key="'tplsec-h-'+sidx").mb-2
          .destaque-sub-title.Poppins {{ secao.title }}
          .destaque-sub-desc.Poppins {{ secao.description }}
        v-layout(row, wrap, :key="'tplsec-r-'+sidx").mb-4
          v-flex(xs12, sm6, md4, lg3, v-for='(cupom, i) in secao.templates', :key="'tpl-'+sidx+'-'+i")
            .cupomCardDestaque(:class="{ 'cupomCardDestaque--bloqueado': bloqueioCupom.ativo }")
              .cupomCard__header
                .cupomCard__badges
                  .cupomCard__badge.cupomCard__badge--destaque(v-if="cupom.destaque == 1")
                    v-icon(x-small) star
                    span Destaque
                  .cupomCard__badge.cupomCard__badge--destaque(v-if="cupom.primeiro_pedido_estabelecimento == 1")
                    v-icon(x-small) star
                    span 1º Pedido
                  v-tooltip(bottom, v-if="cupom.inteligente")
                    .cupomCard__badge.cupomCard__badge--inteligente(slot="activator")
                      v-icon(x-small) auto_awesome
                      span Inteligente
                    span Valores ajustados com base no histórico de pedidos dos últimos 28 dias para melhor performance
                .cupomCard__valor.Poppins
                  span(v-if="cupom.taxa_entrega == 1 || cupom.entrega_gratis") Grátis
                  span(v-else-if="cupom.tipo_desconto == 1") R${{ cupom.valor_desconto }}
                  span(v-else) {{ cupom.valor_desconto }}%
                .cupomCard__valor-label.Poppins
                  span(v-if="cupom.taxa_entrega == 1 || cupom.entrega_gratis") na entrega
                  span(v-else-if="cupom.tipo_desconto == 1") de desconto
                  span(v-else) OFF no pedido
              .cupomCard__body
                .cupomCard__tagline.Poppins {{ cupom.tagline }}
                .cupomCard__details
                  .cupomCard__detail(v-if="cupom.valor_minimo > 0")
                    span.cupomCard__detail-label Pedido mín.
                    span.cupomCard__detail-value R${{ cupom.valor_minimo }}
                  .cupomCard__detail(v-else-if="cupom.valor_desconto_maximo")
                    span.cupomCard__detail-label Desc. máx.
                    span.cupomCard__detail-value R${{ Number(cupom.valor_desconto_maximo).toFixed(2).replace('.', ',') }}
                  .cupomCard__detail
                    span.cupomCard__detail-label Por usuário
                    span.cupomCard__detail-value {{ cupom.quantidade_usuario }}x
                v-btn.cupomCard__cta.cupomCard__cta--destaque.elevation-0.Poppins(type="button", @click="abrirAtivacaoTemplate(cupom)", :disabled="loadingPedidos28d")
                  | Ativar este cupom
                  v-icon(right, small) arrow_forward

    //- ─── Lista de Cupons ───────────────────────────────────────────────────────
    v-container(grid-list-xl, fluid).px-0.pb-0.mt-4
      v-layout(row, wrap).mb-2
        v-flex(xs12)
          .insights-title.Poppins Meus Cupons
          .insights-subtitle.Poppins Gerencie todos os cupons cadastrados do seu estabelecimento

    v-layout.listaCupons(row, wrap)
      v-flex.md12
        v-card
          v-card-text
            v-tabs(v-model="tabAtivos", color="transparent", slider-color="primary").mb-2
              v-tab.Poppins Ativos
              v-tab.Poppins Inativos / Expirados
            v-toolbar.px-0(flat, color="white")
              v-text-field.hidden-sm-and-down.title.inputDefault.Poppins(append-icon="search", outline, label="Pesquisar Cupom", color="primary", v-model="search", clearable, :disabled="loading")
              v-spacer
              v-spacer
              v-btn.padraoBtnCadastro.white--text(@click="abrirCadastroCupom", color="primary", v-if="estabelecimentoSelecionado && estabelecimentoSelecionado.id && !loadingPedidos28d").mb-3.ml-3 Cadastrar
              v-tooltip(top, v-else-if="loadingPedidos28d")
                v-btn(color="accent", slot="activator", disabled, loading).mb-3.ml-3 Cadastrar
                span Carregando dados da loja...
              v-tooltip(top, v-else)
                v-btn(color="accent", slot="activator", disabled).mb-3.ml-3 Cadastrar
                span Entre em contato com o Suporte do Bigou para habilitar esta função.
            v-divider.hidden-sm-and-down
            v-data-table(:headers="headers", :items="listTabela", hide-actions, :search="search", :loading="loading", :pagination.sync="pagination")
              template(slot='items', slot-scope='props')
                td.text-xs-left.Poppins
                  span {{ props.item.codigo }}
                td.text-xs-left.Poppins
                  span(v-if="props.item.entrega_gratis == 1 || props.item.taxa_entrega == 1", style="font-size:12px;font-weight:700;color:#E67E22;")
                    v-icon.mr-1(x-small, style="color:#E67E22;font-size:13px;") local_shipping
                    | Entrega
                  span(v-else, style="font-size:12px;font-weight:700;color:#3060CA;")
                    v-icon.mr-1(x-small, style="color:#3060CA;font-size:13px;") shopping_cart
                    | Itens
                td.text-xs-left.Poppins
                  span(v-if="props.item.destaque == 1", style="font-size:12px;font-weight:700;color:#C9971E;")
                    v-icon.mr-1(x-small, style="color:#C9971E;font-size:13px;") star
                    | Vantagens exclusivas
                  span.grey--text.text--darken-1(v-else, style="font-size:12px;") Lista de cupons
                td.text-xs-left.Poppins
                  span(v-if="props.item.primeiro_pedido_estabelecimento == 1", style="font-size:12px;font-weight:700;color:#3060CA;") Primeiro pedido
                  span.grey--text.text--darken-1(v-else, style="font-size:12px;") Todos
                td.text-xs-left.Poppins
                  div(v-if="props.item.entrega_gratis == 1")
                    span.font-weight-medium 100%
                    div(v-if="props.item.valor_desconto_maximo", style="font-size:11px;color:#999;margin-top:2px;")
                      | Desc. máx. R${{ Number(props.item.valor_desconto_maximo).toFixed(2).replace('.', ',') }}
                  div(v-else-if="props.item.tipo_desconto == 1")
                    span.font-weight-medium {{ props.item.valor_desconto | currency }}
                    div(v-if="props.item.valor_minimo > 0", style="font-size:11px;color:#999;margin-top:2px;")
                      | Pedido mín. R${{ Number(props.item.valor_minimo).toFixed(2).replace('.', ',') }}
                  div(v-else-if="props.item.tipo_desconto == 2")
                    span.font-weight-medium {{ (props.item.valor_desconto * 100).toFixed(0) + "%" }}
                    div(v-if="props.item.valor_desconto_maximo", style="font-size:11px;color:#999;margin-top:2px;")
                      | Desc. máx. R${{ Number(props.item.valor_desconto_maximo).toFixed(2).replace('.', ',') }}
                td.text-xs-left.Poppins
                  div(style="line-height:1.4;")
                    span.font-weight-medium {{ props.item.utilizados }}
                    span.grey--text.text--darken-1  / {{ props.item.quantidade }}
                    span.ml-1(style="font-size:11px;color:#999;") ({{ props.item.disponiveis }} disp.)
                  div(v-if="props.item.quantidade > 0", style="margin-top:2px;")
                    v-progress-linear(:value="Math.round((props.item.utilizados / props.item.quantidade) * 100)", color="primary", height="4", style="max-width:80px;border-radius:2px;", background-color="#e0e0e0")
                td.text-xs-left.Poppins
                  div {{ props.item.data_inicio && props.item.data_fim ? $dayjs(props.item.data_inicio).format('DD/MM/YYYY') + ' até ' + $dayjs(props.item.data_fim).format('DD/MM/YYYY') : 'Sem vigência' }}
                  div(style="font-size:11px;color:#999;margin-top:2px;") {{ formatDiasSemana(props.item.dias_semana) }}
                td.text-xs-left.Poppins {{ props.item.data ? $dayjs(props.item.data).format('DD/MM/YYYY') : '--' }}
                td.text-xs-left
                  v-chip.ma-0.Poppins(label, small, :class="{'lb-danger': !props.item.ativo || props.item.disponiveis <= 0 || !props.item.status, 'lb-primary': props.item.ativo && props.item.status == 1, 'gray': props.item.ativo && props.item.status == -1}").white--text.font-weight-bold {{ !props.item.ativo ? 'INATIVO' : props.item.disponiveis <= 0 ? 'ESGOTADO' : !props.item.status ? 'EXPIRADO' : props.item.status == 1 ? 'VIGENTE' : 'AGENDADO' }}
                  ultima-alteracao.cupomUltimaAlteracao(
                    :log="ultimasAlteracoes[props.item.id]",
                    @click="abrirHistoricoCupom(props.item)"
                  )
                td.text-xs-right
                  v-menu(offset-y)
                    v-btn.Poppins(slot="activator", color="gray", outline, small, style="border-radius: 7px;") Ações
                      v-icon arrow_drop_down
                    v-list.Poppins
                      v-list-tile(v-if="props.item.ativo && !props.item.destaque", @click="$refs.dialogCupom.open(props.item)")
                        v-list-tile-title Editar
                      v-list-tile(v-if="props.item.ativo", @click="abrirArteCupom(props.item)")
                        v-list-tile-title Imagem de divulgação
                      v-list-tile(v-if="props.item.ativo", @click="excluirCupom(props.item)")
                        v-list-tile-title Desativar
                      v-list-tile(v-if="!props.item.ativo", @click="reativarCupom(props.item)")
                        v-list-tile-title Reativar
                      v-list-tile(@click="abrirHistoricoCupom(props.item)")
                        v-list-tile-title Histórico de alterações

  v-dialog(v-model="dialogTipRecorrentes", width="380")
    v-card.Poppins(style="border-radius:14px;")
      v-card-title.font-weight-semibold.Poppins(style="font-size:16px;") Pedidos Recorrentes
      v-card-text.Poppins(style="font-size:14px;color:#5B5B5B;") Pedidos feitos por clientes que já pediram na sua loja
      v-card-actions.Poppins
        v-spacer
        v-btn(flat, color="primary", @click="dialogTipRecorrentes = false") Entendi

  v-dialog(v-model="dialogBloqueio", width="440")
    v-card.Poppins(style="border-radius:14px;", v-if="bloqueioCupom.motivo")
      v-card-title.font-weight-semibold.Poppins(style="font-size:18px;") {{ bloqueioCupom.motivo.titulo }}
      v-card-text.Poppins(style="font-size:14px;color:#5B5B5B;")
        p {{ bloqueioCupom.motivo.mensagem }}
        p.mb-0
          b Como desbloquear:&nbsp;
          | {{ comoDesbloquear }}
      v-card-actions.Poppins
        v-btn.white--text(
          v-if="bloqueioCupom.motivo.tipo === 'suspenso'",
          color="#B3261E",
          depressed,
          @click="abrirSuporte"
        )
          v-icon(left, small) support_agent
          | Falar com o Suporte
        v-spacer
        v-btn(flat, @click="dialogBloqueio = false") Fechar
</template>

<script>
import _ from 'lodash';
import carousel from 'vue-owl-carousel'
import WarningSelect from '@/components/WarningSelect';
import MessagePanel from '@/components/MessagePanel';
import { calcularMetricasCancelamento, avaliarBloqueio } from '@/util/estabelecimentoBloqueio';
import { filtrarSectionsPendentes } from '@/util/cupom';
import DialogCupomForm from '@/components/dialog/DialogCupomForm';
import DialogAtivarCupomTemplate from '@/components/dialog/DialogAtivarCupomTemplate';
import DialogArteDivulgacao from '@/components/dialog/DialogArteDivulgacao';
import DialogHistoricoAlteracoes from '@/components/dialog/DialogHistoricoAlteracoes';
import UltimaAlteracao from '@/components/marketing/UltimaAlteracao';
import { ENTIDADE_CUPOM, buscarUltimasAlteracoes } from '@/util/logAtivacao';
import { registrarContatoSuporte } from '@/util/suporte';

export default {
  components: {
    carousel,
    WarningSelect,
    MessagePanel,
    DialogCupomForm,
    DialogAtivarCupomTemplate,
    DialogArteDivulgacao,
    DialogHistoricoAlteracoes,
    UltimaAlteracao,
  },
  data () {
    return {
      search: '',
      image: null,
      loading: false,
      loadingDialog: false,
      loadingPedidos28d: false,
      loadingBairros: false,
      dialogTipRecorrentes: false,
      dialogBloqueio: false,
      bairrosEstabelecimento: [],
      pedidos28d: [],
      tabAtivos: 0,
      pagination: { sortBy: 'data', descending: true, rowsPerPage: -1 },
      cupons: [],
      ultimasAlteracoes: {},
      headers: [
        { text: 'Código', value: 'codigo' },
        { text: 'Tipo', value: 'tipo', sortable: false },
        { text: 'Destaque', value: 'destaque', sortable: false },
        { text: 'Público', sortable: false },
        { text: 'Valor', value: 'valor_desconto' },
        { text: 'Uso', value: 'utilizados', sortable: false },
        { text: 'Vigência', value: 'data_fim' },
        { text: 'Criado em', value: 'data' },
        { text: 'Status', value: 'status' },
        { text: 'Ações', align: 'right', sortable: false },
      ],
      bairro: {},
      dialog: {
        baixarImagem: false,
      },
      templatesRemotos: [],
      sectionsRemotas: [],
      metricasRemotas: null,
      loadingTemplates: false,
    }
  },

  computed: {
    isCardapioDigital () {
      if(!this.estabelecimentoSelecionado) return;
      return !!this.estabelecimentoSelecionado.cardapio_digital;
    },
    listAtivos () {
      const hoje = this.$dayjs();
      if (this.loading) return [];
      return _.orderBy(
        this.cupons.filter(o =>
          o.ativo === 1 &&
          (!o.data_fim || !this.$dayjs(o.data_fim).isBefore(hoje, 'day'))
        ),
        o => (o.data ? this.$dayjs(o.data).valueOf() : 0),
        ['desc']
      );
    },
    listInativos () {
      const hoje = this.$dayjs();
      if (this.loading) return [];
      return _.orderBy(
        this.cupons.filter(o =>
          o.ativo === 0 ||
          o.disponiveis <= 0 ||
          (o.data_fim && this.$dayjs(o.data_fim).isBefore(hoje, 'day'))
        ),
        o => (o.data ? this.$dayjs(o.data).valueOf() : 0),
        ['desc']
      );
    },
    listTabela () {
      return this.tabAtivos === 0 ? this.listAtivos : this.listInativos;
    },
    kpisCupom () {
      const comCupom = _.filter(this.pedidos28d, o =>
        (o.status == 1 || o.status == 2) && !!o.cupom_desconto_id && o.estabelecimento_cupom == 1
      );
      const totalVendas = _.sumBy(comCupom, o => this.calcBruto(o));
      const qtdPedidos = comCupom.length;
      const novos = _.filter(comCupom, o => o.primeiro_estabelecimento || o.primeiro);
      const novosComCupom = novos.length;
      const recorrentesComCupom = comCupom.length - novosComCupom;
      const totalDesconto = _.sumBy(
        _.filter(comCupom, o => o.estabelecimento_cupom == 1),
        o => o.desconto || 0
      );
      return { totalVendas, qtdPedidos, novosComCupom, recorrentesComCupom, totalDesconto };
    },
    metricas28d () {
      const pedidos = this.pedidos28d;
      const validos = pedidos.filter(o => o.status === 1 || o.status === 2);
      if (validos.length < 5) return null;
      const totais = validos.map(o => o.subtotal || 0);
      const ticketMedio = _.mean(totais);
      const comTaxa = validos.filter(o => o.taxa_entrega > 0);
      const taxaMedia = comTaxa.length ? _.meanBy(comTaxa, 'taxa_entrega') : 0;
      return { ticketMedio, taxaMedia, qtdPedidos: validos.length };
    },
    isInteligente () {
      return this.metricas28d !== null;
    },
    bloqueioCupom () {
      const metricas = calcularMetricasCancelamento(this.pedidos28d);
      const result = avaliarBloqueio({
        estabelecimento: this.estabelecimentoSelecionado,
        metricas: metricas,
        contexto: 'cupom',
      });
      const motivo = (result.motivo && result.motivo.tipo !== 'sem_estabelecimento')
        ? result.motivo
        : null;
      return {
        ativo: !!motivo,
        contratoSuspenso: result.contratoSuspenso,
        bloqueadoPorCancelamento: result.bloqueadoPorCancelamento,
        motivo: motivo,
      };
    },
    comoDesbloquear () {
      const motivo = this.bloqueioCupom.motivo;
      if (motivo && motivo.tipo === 'suspenso') {
        return 'entre em contato com o Suporte do Bigou para regularizar o contrato da loja.';
      }
      const faltam = (motivo && motivo.pedidosParaRegularizar) || 0;
      const plural = faltam === 1 ? 'pedido' : 'pedidos';
      return 'aceite ' + faltam + ' ' + plural + ' sem cancelar nenhum para regularizar.';
    },
    sectionsFiltradas () {
      return filtrarSectionsPendentes(this.sectionsRemotas, this.cupons);
    },
    templatesCarregando () {
      return this.loading || this.loadingTemplates;
    },
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    },
  },
  watch: {
    loadingPedidos28d(newVal) {
      if (!newVal) {
        this.$nextTick(() => this.scrollParaSecao());
      }
    },
  },
  created () {
    window.getApp.$on("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
  },
  beforeDestroy() {
    window.getApp.$off("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
  },
  mounted(){
    this.onChangeEstabelecimento()
  },
  methods: {
    abrirAtivacaoTemplate (cupom) {
      if (this.bloqueioCupom.ativo) {
        this.dialogBloqueio = true;
        return;
      }
      this.$refs.dialogTemplate.open(cupom);
    },
    abrirCadastroCupom () {
      if (this.bloqueioCupom.ativo) {
        this.dialogBloqueio = true;
        return;
      }
      this.$refs.dialogCupom.open();
    },
    abrirSuporte () {
      this.$firebase.logEvent('cupom_suporte_suspensao_clicked');
      registrarContatoSuporte('cupom_dialog_bloqueio', this.estabelecimentoSelecionado);
      const loja = this.estabelecimentoSelecionado;
      const nome = loja ? (loja.nome + ' | ' + loja.id) : '';
      const raw = String((this.$root.FIREBASE_REMOTE_CONFIG && this.$root.FIREBASE_REMOTE_CONFIG.WPP_SUPORTE) || '5532988929726').replace(/\D/g, '');
      const phone = raw.startsWith('55') ? raw : ('55' + raw);
      const texto = encodeURIComponent('Olá, gostaria de saber sobre a suspensão da loja ' + nome);
      window.open('https://api.whatsapp.com/send?phone=' + phone + '&text=' + texto, '_blank');
    },
    formatDiasSemana(diasCsv) {
      if (!diasCsv) return 'Todos os dias';
      const dias = String(diasCsv).split(',').map(n => parseInt(n, 10)).filter(n => !isNaN(n)).sort((a, b) => a - b);
      if (!dias.length) return 'Todos os dias';
      if (dias.length === 7) return 'Todos os dias';
      if (dias.length === 5 && dias.join(',') === '1,2,3,4,5') return 'Dias úteis';
      if (dias.length === 2 && dias.join(',') === '0,6') return 'Fins de semana';
      const labels = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SÁB'];
      return dias.map(d => labels[d]).join(', ');
    },
    calcBruto(o) {
      const comissaoReembolso = this.$dayjs(o.data).isAfter(this.$dayjs('2024-03-31 23:59:59'));
      const reembolso = comissaoReembolso ? (o.reembolso_promocao || 0) : 0;
      return o.estabelecimento_cupom == 1 ? o.total + reembolso : (o.total + (o.desconto || 0) + reembolso);
    },
    scrollParaSecao() {
      const tipo = this.$route.query.scroll;
      if (!tipo) return;
      const refs = {
        fidelizar: 'secaoFidelizar',
        primeiro: 'secaoPrimeiro',
        entrega: 'secaoEntrega',
      };
      const ref = refs[tipo];
      if (ref && this.$refs[ref]) {
        this.$nextTick(() => {
          this.$refs[ref].scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    },
    onChangeEstabelecimento(){
      if(this.estabelecimentoSelecionado) {
        this.cupons = [];
        this.ultimasAlteracoes = {};
        this.templatesRemotos = [];
        this.sectionsRemotas = [];
        this.getCupons();
        this.fetchTemplates();
        this.fetchPedidos28d();
        this.fetchBairrosEstabelecimento();
      }
    },
    async fetchTemplates () {
      const vm = this;
      if (!vm.estabelecimentoSelecionado) return;
      vm.loadingTemplates = true;
      try {
        const res = await vm.$axios.get('/cupom-desconto/templates', {
          params: {
            estabelecimento_id: vm.estabelecimentoSelecionado.id,
            cardapio_digital: vm.isCardapioDigital ? 1 : 0,
          },
        });
        vm.templatesRemotos = (res.data && res.data.templates) || [];
        vm.sectionsRemotas = (res.data && res.data.sections) || [];
        vm.metricasRemotas = (res.data && res.data.metricas) || null;
      } catch (e) {
        vm.templatesRemotos = [];
        vm.sectionsRemotas = [];
        vm.metricasRemotas = null;
      }
      vm.loadingTemplates = false;
    },
    // Busca os pedidos dos últimos 28 dias da loja. Alimenta:
    //   - kpisCupom (bloco de Insights de pedidos com cupom)
    //   - metricas28d (ticket médio / taxa média, usadas em opcoesValorMinimo)
    //   - bloqueioCupom (taxa de cancelamento — status 3, não devolvido por /cupom-desconto/templates)
    async fetchPedidos28d() {
      const vm = this;
      if (!vm.estabelecimentoSelecionado) return;
      vm.loadingPedidos28d = true;
      const hoje = vm.$dayjs();
      const dataInicio = hoje.subtract(28, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
      const dataFim = hoje.subtract(1, 'day').endOf('day').format('YYYY-MM-DD HH:mm:ss');
      try {
        const res = await vm.$axios.get('/pedido', {
          params: {
            estabelecimento_id: vm.estabelecimentoSelecionado.id,
            data_inicio: dataInicio,
            data_fim: dataFim,
            statusList: '1,2,3',
            orderDesc: 'data',
          },
        });
        vm.pedidos28d = res.data;
      } catch (e) {
        vm.pedidos28d = [];
        window.getApp.$emit('APP_ALERT', { color: 'red', text: 'Erro ao carregar indicadores de cupons.' });
      }
      vm.loadingPedidos28d = false;
    },
    async fetchBairrosEstabelecimento () {
      if (!this.estabelecimentoSelecionado) return;
      this.loadingBairros = true;
      try {
        const res = await this.$axios.get('/bairro-estabelecimento', {
          params: {
            estabelecimento_id: this.estabelecimentoSelecionado.id,
            localidade_id: this.estabelecimentoSelecionado.localidade_id,
          },
        });
        this.bairrosEstabelecimento = res.data;
      } catch (e) {
        this.bairrosEstabelecimento = [];
      }
      this.loadingBairros = false;
    },
    async excluirCupom (cupom) {
      const vm = this;
      try {
        const res = await vm.$confirm("Deseja realmente desativar?<br> Essa ação não poderá ser desfeita!");
        if (!res) return;
        vm.loading = true;
        cupom.ativo = 0;
        await vm.$axios.put('/cupom-desconto', cupom);
        window.getApp.$emit('APP_ALERT', { color: 'success', text: "Cupom de desconto desativado com sucesso!" });
        vm.getCupons();
        vm.loading = false;
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao desativar o cupom de desconto!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    async reativarCupom (cupom) {
      const vm = this;
      try {
        const res = await vm.$confirm("Deseja reativar este cupom?");
        if (!res) return;
        vm.loading = true;
        const obj = _.cloneDeep(cupom);
        obj.ativo = 1;
        await vm.$axios.put('/cupom-desconto', obj);
        window.getApp.$emit('APP_ALERT', { color: 'success', text: 'Cupom reativado com sucesso!' });
        vm.getCupons();
        vm.loading = false;
        vm.abrirArteCupom(obj, true, 'reativacao');
      } catch (error) {
        const err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao reativar o cupom!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    abrirArteCupom (cupom, recemAtivado, origem) {
      if (!cupom) {
        return;
      }
      this.$refs.dialogArte.abrirCupom({
        cupom: cupom,
        estabelecimento: this.estabelecimentoSelecionado || {},
        recemAtivado: !!recemAtivado,
        origem: origem || 'lista',
      });
    },
    downloadImageCupom () {
      const vm = this;
      const element = document.getElementById("image_cupom");
      const downloadLink = document.createElement('a');
      downloadLink.setAttribute('href', element.src);
      downloadLink.setAttribute('download', `cupom-bigou-delivery.png`);
      downloadLink.setAttribute('target', '_blank');
      downloadLink.click();
      downloadLink.remove();
    },
    async arteCupom (cupom) {
      const vm = this;
      try {
        vm.loadingDialog = true;
        const response = await vm.$axios.post(`${process.env.VUE_APP_API_IMAGEMAGICK}/cupom-desconto`, cupom);
        if(response.data){
          vm.image = `${process.env.VUE_APP_API_IMAGEMAGICK}/tmp/cupom/${response.data}.png`;
          vm.dialog.baixarImagem = true;
          vm.loadingDialog = false;
        }
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao fazer o download da arte!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    async getCupons () {
      const vm = this;
      try {
        if (!vm.estabelecimentoSelecionado) return;
        vm.loading = true;
        const response = await vm.$axios.get('/cupom-desconto', {
          params: {
            estabelecimento_id: vm.estabelecimentoSelecionado.id,
          },
        });
        vm.cupons = response.data;
        _.forEach(vm.cupons, cupom => {
          cupom.disponiveis = cupom.quantidade - cupom.utilizados;
          cupom.vigencia    = cupom.data_inicio && cupom.data_fim ? 1 : 0;
        });
        vm.loading = false;
        vm.fetchUltimasAlteracoes();
      } catch (error) {
        vm.cupons = [];
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao buscar os dados. Atualize a página!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    async fetchUltimasAlteracoes () {
      const vm = this;
      const lojaId = vm.estabelecimentoSelecionado && vm.estabelecimentoSelecionado.id;
      if (!lojaId) return;
      try {
        const ultimas = await buscarUltimasAlteracoes(vm.$axios, {
          entidade: ENTIDADE_CUPOM,
          estabelecimentoId: lojaId,
        });
        if (vm.estabelecimentoSelecionado && vm.estabelecimentoSelecionado.id === lojaId) {
          vm.ultimasAlteracoes = ultimas;
        }
      } catch (e) {
        vm.ultimasAlteracoes = {};
      }
    },
    abrirHistoricoCupom (cupom) {
      this.$refs.dialogHistorico.abrir({
        entidade: ENTIDADE_CUPOM,
        entidade_id: cupom.id,
        titulo: `Cupom ${cupom.codigo}`,
        estabelecimento_id: this.estabelecimentoSelecionado.id,
      });
    },
    cardHeaderStyle(category) {
      const colors = { novos: '#1d9a5a', ticket: '#3060CA', fidelizar: '#6432b4', entrega: '#E67E22', destaque_fidelizar: '#C9971E', destaque_primeiro: '#C9971E', destaque_entrega: '#C9971E' };
      return { borderTop: '3px solid ' + (colors[category] || colors.novos) };
    },
    cardColorStyle(category) {
      const colors = { novos: '#1d9a5a', ticket: '#3060CA', fidelizar: '#6432b4', entrega: '#E67E22', destaque_fidelizar: '#C9971E', destaque_primeiro: '#C9971E', destaque_entrega: '#C9971E' };
      return { color: colors[category] || colors.novos };
    },
    cardCtaStyle(category) {
      const colors = { novos: '#1d9a5a', ticket: '#3060CA', fidelizar: '#6432b4', entrega: '#E67E22', destaque_fidelizar: '#C9971E', destaque_primeiro: '#C9971E', destaque_entrega: '#C9971E' };
      return { color: colors[category] || colors.novos };
    },
  }
}
</script>
<style lang="scss" scoped>
.Poppins {
  font-family: "Poppins", "Roboto", "Helvetica"!important;
}
.captalize {
  text-transform: capitalize!important;
}
.br-5{
  border-radius: 5px !important;
}
.br-10{
  border-radius: 10px !important;
}
.cardPadrao{
  box-shadow:none !important;
  background-color: #FFFFFF!important;
  border-radius: 10px !important;
  border: 1px solid rgba(0, 0, 0, 0.1)!important;
}
.padraoBtn{
  height: 40px !important;
  width: 100px !important;
  border-radius: 5px !important;
  font-weight: 500;
  box-shadow: none !important;
}
.padraoBtnCadastro{
  height: 40px !important;
  border-radius: 5px !important;
  font-weight: 500;
  box-shadow: none !important;
}
.areaPesquisaTabela{
  .v-toolbar__content{
    padding: 0px!important;
  }
}

.dialogPadrao{
  border-radius: 10px !important;
}
.listaCupons .cupomUltimaAlteracao {
  display: flex;
  max-width: 200px;
  margin-top: 6px;
}
.cardPadraoDialog{
  box-shadow: none!important;
}


// ─── Cupom Card ─────────────────────────────────────────────────────────────
.cupomCard__header {
  padding: 18px 16px 12px;
  background: #fff;
}
.cupomCard__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 6px;
}
.cupomCard__badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  background: rgba(0,0,0,0.04);
  border-radius: 20px;
  padding: 3px 8px;
  margin-bottom: 0;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.cupomCard__badge--inteligente {
  background: rgba(29,154,90,0.12);
  color: #1d9a5a;
  .v-icon {
    color: #1d9a5a !important;
    font-size: 11px !important;
  }
}
.cupomCard__valor {
  font-size: 36px;
  font-weight: 900;
  line-height: 1;
  letter-spacing: -1px;
}
.cupomCard__valor-label {
  font-size: 10px;
  font-weight: 600;
  color: #aaa;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-top: 4px;
}
.cupomCard__body {
  padding: 14px;
  border-top: 1px solid rgba(0,0,0,0.05);
}
.cupomCard__tagline {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  line-height: 1.4;
  margin-bottom: 8px;
}
.cupomCard__details {
  display: flex;
  gap: 6px;
  margin-bottom: 10px;
}
.cupomCard__detail {
  flex: 1;
  min-width: 36px;
  background: #f5f5f7;
  border-radius: 6px;
  padding: 6px 8px;
  text-align: center;
}
.cupomCard__detail-label {
  display: block;
  font-size: 9px;
  color: #aaa;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-weight: 600;
  margin-bottom: 1px;
}
.cupomCard__detail-value {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #1a1a1a;
}
.cupomCard__cta {
  width: 100%;
  border-radius: 9px !important;
  height: 46px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  background: #1E9E57 !important;
  color: #fff !important;
  border: none !important;
  box-shadow: none !important;
  margin: 8px 0 0 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  &:disabled {
    background: #E3E3E6 !important;
    color: #9CA3AF !important;
  }
}
// ─── Destaque Section ────────────────────────────────────────────────────────
.destaque-section-header {
  position: relative;
}
.destaque-sub-title {
  font-size: 15px;
  font-weight: 700;
  color: #444;
  margin-bottom: 2px;
  margin-top: 4px;
}
.destaque-sub-desc {
  font-size: 13px;
  color: #888;
  margin-bottom: 4px;
}
.destaque-benefit-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f5f5f7;
  border: 1px solid rgba(0,0,0,0.08);
  border-radius: 8px;
  padding: 8px 14px;
  margin-top: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #555;
}

// ─── Skeleton loader ─────────────────────────────────────────────────────────
@keyframes tplSkeletonShimmer {
  0%   { background-position: -400px 0; }
  100% { background-position: 400px 0; }
}
.skeleton-line {
  display: block;
  width: 100%;
  height: 14px;
  border-radius: 6px;
  background: #ececec;
  background-image: linear-gradient(90deg, #ececec 0px, #f5f5f5 80px, #ececec 160px);
  background-size: 400px 100%;
  background-repeat: no-repeat;
  animation: tplSkeletonShimmer 1.2s infinite linear;
}
.skeleton-line--lg { height: 22px; width: 55%; }
.skeleton-line--md { height: 16px; width: 35%; }
.skeleton-line--xl { height: 34px; width: 50%; }
.skeleton-line--short { width: 60%; }
.tplSkeleton {
  pointer-events: none;
  .cupomCard__header {
    padding: 18px 16px;
    background: linear-gradient(135deg, #f5f5f5 0%, #ececec 100%);
  }
  .cupomCard__body { padding: 14px 16px 18px; }
  .tplSkeleton__cta { height: 36px; border-radius: 8px; }
}

// ─── Destaque Card ───────────────────────────────────────────────────────────
.cupomCardDestaque {
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  border: 1px solid rgba(0,0,0,0.09);
  width: 100%;
  transition: box-shadow 0.18s ease, transform 0.18s ease;
  position: relative;
  &:hover {
    box-shadow: 0 4px 16px rgba(0,0,0,0.10);
    transform: translateY(-2px);
  }
}
.cupomCardDestaque--bloqueado {
  opacity: 0.5;
  filter: grayscale(40%);
  &:hover {
    box-shadow: none;
    transform: none;
  }
}
.cupomCard__badge--destaque {
  background: linear-gradient(135deg, rgba(201, 151, 30, 0.15), rgba(212, 160, 23, 0.10));
  color: #C9971E;
  .v-icon {
    color: #C9971E !important;
    font-size: 11px !important;
  }
}
.cupomCard__cta--destaque {
  &:hover {
    background: #178a4d !important;
  }
}

.cupomCard__cancelar {
  text-align: center;
  margin-top: 8px;
  a {
    font-size: 12px;
    color: #888;
    cursor: pointer;
    text-decoration: none;
    font-family: 'Poppins', sans-serif;
    &:hover { color: #555; }
  }
}
.cupomCard__sugestao {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f0faf4;
  border-radius: 8px;
  padding: 6px 10px;
  margin-bottom: 8px;
}
.cupomCard__sugestao-label {
  font-size: 11px;
  color: #888;
  font-family: 'Poppins', sans-serif;
  white-space: nowrap;
}
.cupomCard__sugestao-code {
  font-size: 13px;
  font-weight: 700;
  color: #1d9a5a;
  letter-spacing: 0.5px;
  flex: 1;
}
.cupomCard__sugestao-usar {
  font-size: 11px;
  font-weight: 600;
  color: #1d9a5a;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  font-family: 'Poppins', sans-serif;
  &:hover { text-decoration: underline; }
}

// ─── Insights ───────────────────────────────────────────────────────────────
.insights-title {
  font-size: 20px;
  font-weight: 500;
  color: #1a1a1a;
}
.insights-subtitle {
  font-size: 13px;
  color: #888;
  margin-top: 2px;
}
.cupom-smart-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(29,154,90,0.12);
  color: #1d9a5a;
  border-radius: 20px;
  padding: 2px 10px;
  margin-left: 10px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  vertical-align: middle;
}

// ─── KPI Cards ──────────────────────────────────────────────────────────────
.kpi-card {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.07);
  height: 100%;
}
.kpi-card__icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  &--green  { background: rgba(29,154,90,0.12); }
  &--blue   { background: rgba(48,96,202,0.12); }
  &--purple { background: rgba(100,50,180,0.12); }
  &--red    { background: rgba(255,75,75,0.12); }
}
.kpi-card__label {
  font-size: 11px;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.kpi-card__info {
  font-size: 14px !important;
  color: #bbb;
  cursor: pointer;
}
.kpi-card__value {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.2;
}
.kpi-card__value--skeleton {
  height: 28px;
  width: 80%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.2s infinite;
  border-radius: 8px;
  margin: 4px 0;
}
@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
.kpi-card__sub {
  font-size: 12px;
  color: #aaa;
  margin-top: 4px;
}

// ─── 5-column layout ────────────────────────────────────────────────────────
.lg2dot4 {
  flex: 0 0 20%;
  max-width: 20%;
}
@media (max-width: 1264px) { .lg2dot4 { flex: 0 0 50%; max-width: 50%; } }
@media (max-width: 600px)  { .lg2dot4 { flex: 0 0 100%; max-width: 100%; } }


@media screen and (max-width: 960px) {
  .cardPadrao{
    width: 100% !important;
  }
}
</style>

<style lang="scss">
.inputDefault .v-input__control .v-input__slot{
  background-color: #f6f6f6!important;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, .15)!important;
}

.inputDefault.v-input.v-input--is-focused .v-input__control .v-input__slot{
  border: 1px solid #1d9a5a !important;
}

.cardApple{
  background-color: rgba(250, 250, 252, 0.8)!important;
  backdrop-filter: saturate(180%) blur(20px);
  box-shadow: none!important;
}
.areaPesquisaTabela .v-toolbar__content{
  padding: 0px!important;
}

.v-dialog {
  border-radius: 17px!important;
  border: 6px solid #d2d2d7!important;
  margin: 14px!important;
}
.areaPontilhada{
  border-radius: 13px !important;
  border: 1px dashed rgba(0,0,0,0.54);
  padding: 7px 12px !important;

  .v-input__control{
    width: 100%!important;
  }
  .v-input__control .v-input__slot .v-input--radio-group__input{
    display: flex !important;
    justify-content: space-evenly;

    .v-radio{
      margin: 0!important;
    }
  }
}

.v-dialog::-webkit-scrollbar {
    width: 0px;
}

.v-dialog::-webkit-scrollbar-track {
    -webkit-box-shadow: none;
}

.listaCupons .v-toolbar__content{
  padding: 0!important;
}

// ─── Coupon Create/Edit Dialog Chips ─────────────────────────────────────────
.cupomDialog__field-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #888;
  margin-bottom: 8px;
  font-family: 'Poppins', sans-serif;
  display: flex;
  align-items: center;
}
.cupomDialog__field-hint {
  font-size: 11px;
  font-weight: 500;
  color: #1d9a5a;
  margin-top: -4px;
  margin-bottom: 8px;
  font-family: 'Poppins', sans-serif;
}
.cupomDialog__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}
.cupomDialog__chip {
  padding: 6px 16px;
  border-radius: 20px;
  border: 1.5px solid #d2d2d7;
  font-size: 13px;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  cursor: pointer;
  color: #444;
  background: #fff;
  transition: all 0.15s ease;
  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
  &--active {
    border-color: #1d9a5a;
    color: #1d9a5a;
    background: rgba(29, 154, 90, 0.08);
  }
}

</style>
